import React from "react";
import OnestockProductInfo from "components/Product-Info-Pages/Onestock/OnestockProductInfo";

const OneStock = () => <OnestockProductInfo />;

export default OneStock;
